import { useState, useEffect } from 'react';
import api from '../utils/api';

export function useShiftTypes() {
  const [shiftTypes, setShiftTypes] = useState([]);
  useEffect(() => {
    api.get('/settings/shift-types')
      .then(r => setShiftTypes(r.data || []))
      .catch(() => {});
  }, []);
  return shiftTypes;
}

export function useDocumentCategories(appliesTo = 'client') {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    api.get('/settings/document-categories')
      .then(r => setCats((r.data || []).filter(c => !appliesTo || c.applies_to === appliesTo)))
      .catch(() => {});
  }, [appliesTo]);
  return cats;
}

export function useNoteTypes() {
  const [noteTypes, setNoteTypes] = useState([]);
  useEffect(() => {
    api.get('/settings/note-types')
      .then(r => setNoteTypes(r.data || []))
      .catch(() => {});
  }, []);
  return noteTypes;
}

export function useJobTitles() {
  const [jobTitles, setJobTitles] = useState([]);
  useEffect(() => {
    api.get('/settings/job-titles')
      .then(r => setJobTitles(r.data || []))
      .catch(() => {});
  }, []);
  return jobTitles;
}
